import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
// components
import TableComponent from 'components/Table'
import { ColumnsType } from 'components/Table/interface'
import BaseLayout from 'components/BaseLayout'
import Modal from './Modal'
// helpers
import get from 'lodash/get'

const columns: ColumnsType<any> = [
  {
    title: 'Usuario',
    dataIndex: 'identity_first_name',
    type: 'userCell'
  },
  {
    title: 'Email',
    dataIndex: 'identity_email'
  },
  {
    title: 'Teléfono',
    dataIndex: 'identity_phone'
  },
  {
    title: 'Puntos disponibles',
    dataIndex: 'total_points_earned'
  },
  {
    title: 'Estado',
    dataIndex: 'identity_uuid',
    type: 'status'
  },
  {
    title: 'Editar',
    dataIndex: 'identity_uuid',
    type: 'releaseUser',
    fixed: 'right',
    width: 40
  }
]

const Layout: React.FC = () => {
  const {
    states: { page, searchInput },
    actions: { setPage, setSearchInput },
    queryHandler: { isFetching, data: dataQuery }
  } = useContext(Context)
  const [valShown, setValShown] = useState('')

  const data = get(dataQuery, 'data', [])
  const paginationInfo = get(dataQuery, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 9,
    totalPages: 1,
    totalRecords: 1
  })

  useEffect(() => {
    const scheduledChange = setTimeout(() => {
      if (valShown !== searchInput) setSearchInput(valShown)
    }, 600)

    return () => clearTimeout(scheduledChange)
  }, [valShown])

  return (
    <>
      <BaseLayout title="Usuarios Fraudulentos" bordered={false}>
        <Input
          size="large"
          placeholder="Busca por nombre, email o número celular"
          prefix={<SearchOutlined />}
          value={valShown}
          onChange={e => setValShown(e.target.value)}
        />
        <TableComponent
          columns={columns}
          data={data}
          loading={isFetching}
          page={page}
          rows={9}
          total={paginationInfo.totalRecords}
          setPage={setPage}
          emptyData={data.length === 0 && !isFetching}
        />
      </BaseLayout>
      <Modal />
    </>
  )
}

export default Layout
